var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col text-center" }, [
      _vm.isInfo
        ? _c("img", {
            attrs: {
              src: require("@/assets/IC_Msg_Information.svg"),
              alt: "icon",
            },
          })
        : _vm._e(),
      _vm.isError
        ? _c("img", {
            attrs: { src: require("@/assets/IC_Msg_Error.svg"), alt: "icon" },
          })
        : _vm._e(),
      _vm.isWarning
        ? _c("img", {
            attrs: { src: require("@/assets/IC_Msg_Alert.svg"), alt: "icon" },
          })
        : _vm._e(),
      _vm.isSuccess
        ? _c("img", {
            attrs: { src: require("@/assets/IC_Msg_Sucess.svg"), alt: "icon" },
          })
        : _vm._e(),
      _c("div", { staticClass: "info mt-2 d-flex justify-content-center" }, [
        _c("p", { staticClass: "w-50" }, [_vm._v(_vm._s(_vm.message))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }